<template>
  <div class="login_cont_box">
    <div class="login_data">
      <p class="close" @click="closeLogin()"><img src="@/assets/close_icon.png" alt="" /></p>
      <p class="logo"><img src="@/assets/m/login_logo.png" alt=""></p>
      <p class="title">登录</p>
      <div class="form_cont">
        <ul>
          <li><input type="text" v-model="formData.account" placeholder="请输入账号" /></li>
          <li><input type="password" v-model="formData.password" placeholder="请输入密码" /></li>
        </ul>
         <p class="tips">账号与广东省总工会劳模管理平台账号一致</p>
        <div class="btn" @click="submitBtn()">登录</div>
       
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "list",
  components: {},

  data() {
    return {
      formData:{
        account:'',//账号
        password:'',//密码
      }
    };
  },
  mounted() {},
  methods: {
    ...mapMutations(['CloseMLoginModal', 'ShowTipModal', 'ClearUserInfo']), //登录弹窗

    // 登录按钮
    submitBtn(){
      if(!this.formData.account){
        this.$message.error('请输入账号')
      }
      if(!this.formData.password){
        this.$message.error('请输入密码')
      }
      let formData = new FormData()
      formData.append('account',this.formData.account)
      formData.append('password',this.formData.password)
      this.$axios.post(`/user/login`,formData).then(res=>{
        // console.log(res)
        if(res.code==1){
          localStorage.setItem('userInfo',JSON.stringify(res.data.userinfo))
          localStorage.setItem('auth',res.data.userinfo.token)
          this.CloseMLoginModal()
          location.reload()
        }else{
          this.$message.error(res.msg)
        }
      })
    },


    // 关闭登录弹框
    closeLogin(){
      for(let i in this.formData){
        this.formData[i]=''
      }
        this.CloseMLoginModal()
    }
  },
};
</script>
<style scoped lang="scss">
@import "@/utils/common.scss";
.login_cont_box {
 position: fixed;
 left: 0;
 top: 0;
 width: 100%;
 height: 100%;
 z-index: 88;
 background: url('@/assets/m/login_bgm.png') no-repeat;
 background-size: 100% 100%;
 .login_data{
  p.close{
    display: flex;
    justify-content: flex-end;
    margin: 20px 16px 50px;
    img{

      transform: rotate(45deg);
      width: 30px;
    }
  }
  p.logo{
    margin-left: 14px;
    img{
      width: 314px;
      height: 106px;
    }
  }
  p.title{
    margin-left: 16px;
    margin-top: 24px;
    font-size: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #333333;
    position: relative;
    display: inline-block;
  }
  p.title::after{
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    width: 32px;
    height: 6px;
    background: rgba(0,87,181,0.2);
    border-radius: 143px 143px 143px 143px;
  }
  .form_cont{
    margin: 30px 16px ;
    li{
      background: #fff;
      margin-bottom: 14px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      input{
        background: #fff;
        outline: none;
        width: 90%;
        height: 90%;
      }
    }
    p.tips{
      font-size: 13px;
      color: #BCC3CB;
      line-height: 17px;
    }
    div.btn{
      margin: 40px 16px;
      height: 54px;
      background: linear-gradient(90deg, #0057B5 0%, #2D74C3 100%);
      border-radius: 4px 4px 4px 4px;
      font-size: 16px;
      color: #FFFFFF;
      text-align: center;
      line-height: 54px;
    }
  }
 }
}
</style>